<ion-footer class="footer ion-padding-horizontal ion-align-items-center">
  <ion-button 
  class="round-corners ion-no-padding small-padding"
  [ngClass]="{'active-footer-btn': activeSection.accounts}"
  (click)="navigateToPage(PageURL.ACCOUNTS)" 
  [fill]="activeSection.accounts ? 'solid' : 'clear'"  
  shape="round">
    <img [ngClass]="{'footer-icon-active wb-filter-mycustom': activeSection.accounts, 'footer-icon': !activeSection.accounts}"
      class="ion-margin-end" 
      [src]="accountsIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
      *ngIf="activeSection.accounts" >{{'bottomNavigation_accounts'|translate}}</ion-text>
  </ion-button>
  <ion-button class="round-corners ion-no-padding small-padding"
  [ngClass]="{'active-footer-btn': activeSection.payments}"
  (click)="navigateToPage(PageURL.PAYMENTS)" 
  [fill]="activeSection.payments ? 'solid' : 'clear'"  
  shape="round">
    <img [ngClass]="{'footer-icon-active wb-filter-mycustom': activeSection.payments, 'footer-icon': !activeSection.payments}"
      class="ion-margin-end" 
      [src]="paymentsIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
      *ngIf="activeSection.payments" >{{'bottomNavigation_payments'|translate}}</ion-text>
  </ion-button>
  <ion-button 
  class="round-corners ion-no-padding small-padding" 
  [ngClass]="{'active-footer-btn': activeSection.markets}"
  (click)="navigateToPage('Markets')" 
  [fill]="activeSection.markets ? 'solid' : 'clear'" 
  shape="round">
    <img [ngClass]="{'footer-icon-active wb-filter-mycustom': activeSection.markets, 'footer-icon': !activeSection.markets}"
      class="ion-margin-end" 
      [src]="marketsIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}"
      *ngIf="activeSection.markets" >{{'bottomNavigation_markets'|translate}}</ion-text>
  </ion-button>
  <!-- <ion-button 
  class="round-corners ion-no-padding small-padding" 
  [ngClass]="{'active-footer-btn': activeSection.tools}"
  (click)="navigateToPage('Tools')" 
  [fill]="activeSection.tools ? 'solid' : 'clear'" 
  shape="round">
    <img [ngClass]="{'footer-icon-active': activeSection.tools, 'footer-icon': !activeSection.tools}"
      class="ion-margin-end" 
      [src]="getToolsIcon(router.url)"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}"
      *ngIf="activeSection.tools" >{{'Tools'|translate}}</ion-text>
  </ion-button> -->
  <ng-container *ngIf="userInfo">
    <ion-button *ngIf="userInfo.copytrading && (userInfo.Organization != 'Jordan' && userInfo.Organization != 'Cyprus' && userInfo.Organization != 'Palestine')"
    class="round-corners ion-no-padding small-padding" 
    [ngClass]="{'active-footer-btn': activeSection.copytrade}"
    (click)="navigateToPage(PageURL.COPYTRADING)"
    [fill]="activeSection.copytrade ? 'solid' : 'clear'"
    shape="round">
    <img [ngClass]="{'footer-icon-active wb-filter-mycustom': activeSection.copytrade, 'footer-icon': !activeSection.copytrade}"
    class="ion-margin-end" 
    [src]="copytradeIcon"/>
      <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
        *ngIf="activeSection.copytrade" >{{'pageTitle_CopyTrading'|translate}}</ion-text>
    </ion-button>
  </ng-container>
  <ion-button 
  class="round-corners ion-no-padding small-padding" 
  [ngClass]="{'active-footer-btn': activeSection.more}"
  (click)="navigateToPage(PageURL.VIEW_MORE)"
  [fill]="activeSection.more ? 'solid' : 'clear'"
  shape="round">
  <img [ngClass]="{'footer-icon-active wb-filter-mycustom': activeSection.more, 'footer-icon': !activeSection.more}"
  class="ion-margin-end" 
  [src]="viewMoreIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
      *ngIf="activeSection.more" >{{'bottomNavigation_more'|translate}}</ion-text>
  </ion-button>
</ion-footer>
